const styles = {
  searchBar: {
    color: 'neutral.darkest',
    width: '100%',

    display: 'flex',
    alignItems: 'center',
    columnGap: { xs: 0.5, md: 1 },

    '& #p-single-input-form': {
      flexGrow: 2,
      display: 'flex',
      height: 56,
      color: 'neutral.darkest',

      '& .MuiInputBase-root': {
        backgroundColor: 'neutral.light',
        p: '12px',
        pr: { xs: '8px', md: '12px' },
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        '&:hover': {
          boxShadow: 'none',
        },

        '& input': {
          backgroundColor: 'neutral.light',
          p: 0,
        },
        '& .MuiInputAdornment-root button': {
          p: '4px',
          '&:hover': {
            borderRadius: '50%',
            boxShadow: 'none',
          },
        },
      },
    },
    '& #p-single-input-form-button': {
      alignSelf: 'auto',
      color: 'neutral.darkest',
      p: { xs: 0, md: 'inherit' },
      width: { xs: 48, md: 103 },
      minWidth: { xs: 48, md: 103 },
      borderTopRightRadius: '8px',
      borderBottomRightRadius: '8px',
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      fontWeight: 700,
      fontSize: 14,
    },
  },
}

export default styles
